import React from 'react';
import { connect } from 'react-redux';
import { compose, withProps, lifecycle, withState } from 'recompose';
import styled from 'styled-components';
import { Tabs as _Tabs } from 'antd';

import { actions as productActions } from 'modules/product';
import { actions as appActions } from 'modules/app';
import { actions as wishlistActions } from 'modules/wishlist';
import ProductSearch from 'components/Product/ProductSearch';
import ProductList from 'components/Product/ProductList';
import ProductBookModal from 'components/Product/ProductBookModal';
import { redirectIfNotLoggedIn } from 'utils/HOCs/redirect';
import { loadingFromStore } from 'utils/HOCs/loading';

const { TabPane } = _Tabs;

const Container = styled.div`
  margin-top: -15px;
  > div {
    margin-bottom: 20px;
  }
`;

const Tabs = styled(_Tabs)`
  margin: 0 -25px !important;
  .ant-tabs-nav-wrap {
    padding: 0 25px;
    background-color: ${props => props.theme.white};
  }
`;

const enhance = compose(
  redirectIfNotLoggedIn,
  connect(
    state => ({
      products: state.product.products,
      isLoadingProducts: state.product.isLoadingProducts,
      isStationsLoaded: state.app.isStationsLoaded,
      count: state.product.count,
      currentPage: state.product.currentPage,
      isLoadingWishlist: state.wishlist.isLoading,
      wishlists: state.wishlist.wishlists,
      localWishlists: state.wishlist.localWishlists,
      exchangeRate: {
        rates: state.app.exchangeRates,
        currency: 'THB',
        quantity: 2
      },
    }),
    {
      ...productActions,
      getAllStations: appActions.getAllStations,
      ...wishlistActions
    }
  ),
  withState('query', 'setSearchQuery', { name: '', city: 'all', productType: 'all' }),
  withState('activeTab', 'setActiveTab', 'favorite'),
  withProps(
    props => ({
      selectProduct: (product) => {
        props.openModal(product.name);
        Promise.all([
          props.loadAvailability(product._id),
          props.getProduct(product.slug),
        ]);
      },
      closeModal: () => props.deselectProduct(),
      onPaginate: (page, pageSize) => {
        const skip = (page - 1) * pageSize;
        props.getProducts(skip, props.query);
      },
      onSearch: () => {
        props.getProducts(0, props.query);
      }
    })
  ),
  lifecycle({
    componentDidMount() {
      this.props.getProducts(0, this.props.query);
      this.props.getWishlists();
      if (!this.props.isStationsLoaded) this.props.getAllStations();
    }
  }),
  loadingFromStore('app.isLoadingExchangeRates')
);

const Products = props => {
  const { products, exchangeRate, count, isLoadingProducts, currentPage, wishlists, localWishlists, activeTab, } = props;
  return (
    <Container>
      <ProductSearch
        onQueryChange={(query) => props.setSearchQuery(query)}
        onSearch={props.onSearch}
        onSearchSuccess={() => props.setActiveTab('all')}
      />
      <Tabs activeKey={activeTab} onChange={props.setActiveTab}>
        <TabPane tab={`Your Favorite${wishlists.length > 0 ? ` (${wishlists.length})` : ''}`} key="favorite">
          <ProductList
            products={wishlists}
            onSelect={props.selectProduct}
            rate={exchangeRate}
            noPaginate
            loading={props.isLoadingWishlist}
            localWishlists={localWishlists}
            wishlistFn={{ add: props.addWishlist, remove: props.removeWishlist }}
          />
        </TabPane>
        <TabPane tab={`All Products (${count})`} key="all">
          <ProductList
            products={products}
            onSelect={props.selectProduct}
            rate={exchangeRate}
            onPaginate={props.onPaginate}
            allCount={count}
            loading={isLoadingProducts}
            currentPage={currentPage}
            localWishlists={localWishlists}
            wishlistFn={{ add: props.addWishlist, remove: props.removeWishlist }}
          />
        </TabPane>
      </Tabs>
      <ProductBookModal />
    </Container>
  );
};

export default enhance(Products);



// WEBPACK FOOTER //
// ./src/pages/Product/Products.js